import {LinkExternalIcon} from '@primer/octicons-react'
import {Link} from '@primer/react'
import {graphql} from 'react-relay'
import {useFragment} from 'react-relay/hooks'

import {LABELS} from '../constants/labels'
import {createIssueEventExternalUrl} from '../utils/urls'
import type {TransferredEvent$key} from './__generated__/TransferredEvent.graphql'
import {TimelineRow} from './row/TimelineRow'
import styles from './TransferredEvent.module.css'

type TransferredEventProps = {
  queryRef: TransferredEvent$key
  issueUrl: string
  onLinkClick?: (event: MouseEvent) => void
  highlightedEventId?: string
  refAttribute?: React.RefObject<HTMLLIElement | null>
}

export function TransferredEvent({
  queryRef,
  issueUrl,
  onLinkClick,
  highlightedEventId,
  refAttribute,
}: TransferredEventProps): React.ReactElement {
  const {actor, createdAt, fromRepository, databaseId} = useFragment(
    // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
    graphql`
      fragment TransferredEvent on TransferredEvent {
        databaseId
        actor {
          avatarUrl(size: 64)
          login
          profileResourcePath
          __typename
          ... on Bot {
            isCopilot
            isAgent
            displayName
          }
          ... on User {
            name
          }
          ... on EnterpriseUserAccount {
            name
          }
          ... on Mannequin {
            name
          }
        }
        createdAt
        fromRepository {
          nameWithOwner
          url
        }
      }
    `,
    queryRef,
  )

  const highlighted = String(databaseId) === highlightedEventId
  return (
    <TimelineRow
      highlighted={highlighted}
      refAttribute={refAttribute}
      actor={actor}
      createdAt={createdAt}
      deepLinkUrl={createIssueEventExternalUrl(issueUrl, databaseId)}
      onLinkClick={onLinkClick}
      leadingIcon={LinkExternalIcon}
    >
      <TimelineRow.Main>
        {LABELS.timeline.transferredThis}
        <Link href={`${fromRepository?.url}`} inline className={styles.Link}>
          {fromRepository?.nameWithOwner}
        </Link>
      </TimelineRow.Main>
    </TimelineRow>
  )
}
